import { generatePath } from "react-router-dom";
import CollectionLink from "./CollectionLink";

export default class SpMerchantCollectionLink extends CollectionLink {
  constructor(merchantId, name, icon, path, authenticationName, spMerchantId, subLinks, subtitle) {
    super(merchantId, name, icon, path, authenticationName, subLinks, subtitle);
    this.spMerchantId = spMerchantId;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId, spMerchantId: this.spMerchantId });
  }
}
